import AboutUsTimelineBlockTitle from "./timeline-block-title/timeline-block-title";
import AboutUsTimelineBlockList from "./timeline-block-list/timeline-block-list";
import "./about-us-timeline-block.sass";

const AboutUsTimelineBlock = () => {
  return (
    <div className="about-us-timeline-block">
      <AboutUsTimelineBlockTitle />

      <AboutUsTimelineBlockList />
    </div>
  );
};

export default AboutUsTimelineBlock;
